import React, { useEffect, useState } from 'react'
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { loaderActions } from '../../../../_actions/loader.actions';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { useDispatch } from 'react-redux';
import { formatDate, getDateCombination, isImageValidPng } from '../../../commonClass/CommonValidation';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import CustomTable from '../../../../customControl/CustomTable';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const { RangePicker } = DatePicker;

const Banners = ({ travelCategoryId, useredit, useradd }) => {
    const getFolderName = (id) => {
        switch (id) {
            case 1: return 'Flights';
            case 2: return 'Holidays';
            case 5: return 'Hotels';
            default: return '';
        }
    }

    const user = GetLocalStorage();
    const dispatch = useDispatch();
    const folderName = getFolderName(travelCategoryId);
    const subFolderName = 'Banners';
    const [deletImageList, setDeleteImageList] = useState([]);
    const [disabledRanges, setDisabledRanges] = useState([]);
    const [errors, setErrors] = useState({});

    const [bannerList, setBannerList] = useState([]);
    const [bannerForm, setBannnerForm] = useState({
        HomePageBannerId: 0,
        TravelCategoryId: travelCategoryId,
        ImageName: '',
        ImagePath: '',
        Path: '',
        File: '',
        needToUpload: '',
        uploaded: '',
        IsCustomDate: false,
        FromDate: null,
        ToDate: null,
        UserId: user?.userMasterID
    });

    const selectedDateDisable = (data) => {
        const selectedDate = data.reduce((acc, banner) => {
            const startDate = banner?.FromDate?.split('T')?.[0];
            const endDate = banner?.ToDate?.split('T')?.[0];

            if (startDate && endDate) {
                acc.push({ startDate, endDate });
            }

            return acc;
        }, []);

        setDisabledRanges(selectedDate);
    }

    //#region Call GET API Function
    const gethomepagebannerbytravelcategoryid = async () => {
        const homepagebannerbytravelcategoryid = await getAllData(`/master/v1/gethomepagebannerbytravelcategoryid?travelCatergoryId=${travelCategoryId}`);
        if (homepagebannerbytravelcategoryid?.status) {
            setBannerList(homepagebannerbytravelcategoryid?.data);
            selectedDateDisable(homepagebannerbytravelcategoryid?.data);
        }
    }
    //#endregion

    //#region Check Token and Call GET API Function in useEffect with travelCategoryId
    useEffect(() => {
        async function fetchData() {
            let statusoftoken = await verifytoken();

            if (statusoftoken) {
                gethomepagebannerbytravelcategoryid();
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                dispatch(loaderActions.end());
            }
        }

        if (travelCategoryId) { fetchData(); }
    }, [travelCategoryId])
    //#endregion

    //#region Image Upload Function
    const handleUploadDoc = (e) => {
        setErrors({});
        const files = Array?.from(e?.target?.files || []);
        let newFileType = files?.filter((file) => isImageValidPng(file?.name))
        let newFileSize = newFileType?.filter((file) => ((file?.size / 1024) / 1024) < 25)
        let error = {}
        if (files?.length !== newFileType?.length) {
            error.imageUpload = 'Only PNG file type is accepted.';
            setErrors(error);
            e.target.value = null
        }
        else if (files?.length !== newFileSize?.length) {
            error.imageUpload = 'Cannot upload file that exceeds 25 MB.';
            setErrors(error);
            e.target.value = null
        }
        else {
            const filename = getDateCombination(newFileSize?.[0]?.name);
            !bannerForm.File && deletehomepagebannerbyid(bannerForm?.ImagePath);
            setBannnerForm({
                ...bannerForm,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/${folderName}/${subFolderName}/${filename}`,
                Path: `CMS/Merchandising/${folderName}/${subFolderName}/`,
                File: newFileSize?.[0],
                needToUpload: true,
                uploaded: false,
            });
        }
    }
    //#endregion

    //#region Delete Image 
    const deletehomepagebannerbyid = async (bannerImagePath) => {
        document.getElementById('imageUpload').value = '';
        setDeleteImageList([...deletImageList, bannerImagePath]);
        setBannnerForm({
            ...bannerForm, ImageName: '', ImagePath: '', Path: '', File: '', needToUpload: false, uploaded: false
        });
    }
    //#endregion

    const isValidDate = () => {
        let isError = true;
        let errorMessage = {};
        if (bannerForm.ImagePath?.length <= 0) {
            errorMessage['ImagePath'] = 'Cannot leave blank, input is mandatory.'
            isError = false
        }
        if (bannerForm.IsCustomDate && (!bannerForm.FromDate || !bannerForm.ToDate)) {
            errorMessage['FromDate'] = 'Cannot leave blank, input is mandatory.'
            isError = false
        }
        setErrors(errorMessage);
        return isError;
    }

    //#region Add Button Function
    const AddBanner = async () => {
        if (isValidDate()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();

            if (statusoftoken) {
                const insertupdatehomepagebanner = await postUsersData(
                    '/master/v1/insertupdatehomepagebanner',
                    { ...bannerForm, TravelCategoryId: travelCategoryId }
                );

                if (insertupdatehomepagebanner.status) {
                    if (bannerForm?.needToUpload) {

                        try {
                            let uploaded = await ImageUpload(bannerForm?.Path, bannerForm?.ImageName, bannerForm?.File);

                            if (deletImageList?.length > 0) {
                                deletImageList.map(async (ImagePath) => {
                                    await ImageDelete(ImagePath);
                                })
                            }

                            bannerForm.uploaded = uploaded
                        } catch (error) {
                            console.error(`Error Upload Image: ${error}`)
                            dispatch(loaderActions.end())
                        }
                    };

                    clearData();
                    gethomepagebannerbytravelcategoryid();
                    dispatch({ type: 'ALERTING', message: insertupdatehomepagebanner.message });
                    dispatch(loaderActions.end());
                } else {

                    dispatch({ type: 'ALERTING', message: insertupdatehomepagebanner.message })
                    dispatch(loaderActions.end());
                    return;
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }
    //#endregion

    //#region Clear Button Function
    const clearData = () => {
        document.getElementById('imageUpload').value = '';
        setErrors({});
        setBannnerForm({
            HomePageBannerId: 0,
            TravelCategoryId: travelCategoryId,
            ImageName: '',
            ImagePath: '',
            Path: '',
            File: '',
            needToUpload: false,
            uploaded: '',
            IsCustomDate: false,
            FromDate: null,
            ToDate: null,
            UserId: user?.userMasterID
        });
        selectedDateDisable(bannerList)
    }
    //#endregion

    const formatDates = (date) => {
        if (!date) return '';
        return dayjs(date).format('YYYY-MM-DD');
    }

    const handleDateChange = (dates) => {
        setErrors({})
        setBannnerForm({
            ...bannerForm,
            FromDate: dates?.[0] ? formatDates(dates[0]) : null,
            ToDate: dates?.[1] ? formatDates(dates[1]) : null
        })
    };

    const onEditorView = (data, type) => {
        const selectedDate = Array.isArray(bannerList) ? bannerList.reduce((acc, banner) => {
            if (data?.HomePageBannerId !== banner?.HomePageBannerId) {
                const startDate = banner?.FromDate?.split('T')?.[0];
                const endDate = banner?.ToDate?.split('T')?.[0];

                if (startDate && endDate) {
                    acc.push({ startDate, endDate });
                }
            }
            return acc;
        }, []) : [];

        setDisabledRanges(selectedDate);

        setErrors({});
        setBannnerForm({
            HomePageBannerId: data?.HomePageBannerId,
            TravelCategoryId: data?.TravelCategoryId,
            ImagePath: data?.ImagePath,
            ImageName: data?.ImageName,
            IsCustomDate: data?.IsCustomDate,
            FromDate: data?.FromDate?.split('T')?.[0],
            ToDate: data?.ToDate?.split('T')?.[0],
            IsType: type
        })
    };

    const columns = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            selector: (data, index) => index + 1,
        },
        {
            name: 'Banner Image',
            sortable: true,
            float: "left",
            selector: (data) => data?.ImageName,
        },
        {
            name: 'From Date',
            sortable: true,
            float: "left",
            selector: (data) => new Date(data?.FromDate),
            format: (data) => data?.FromDate ? formatDate(data?.FromDate) : '-',
        },
        {
            name: 'To Date',
            sortable: true,
            float: "left",
            selector: (data) => new Date(data?.ToDate),
            format: (data) => data?.ToDate ? formatDate(data?.ToDate) : '-',
        },
        {
            name: 'Type',
            sortable: true,
            float: "left",
            selector: (data) => data?.Type,
        },
        {
            name: 'Edit',
            selector: data =>
                <button type='button'
                    className='border-0 p-0 bg-body set_disableclr'
                    onClick={() => onEditorView(data, 'edit')}
                // disabled={!useredit}
                ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button'
                className='border-0 p-0 bg-body set_disableclr'
                onClick={() => onEditorView(data, 'view')}
            ><i className="fa fa-eye" ></i></button>
        }
    ];

    // Convert strings to dayjs objects for comparison
    const parsedRanges = disabledRanges.map(range => ({
        start: dayjs(range.startDate, 'YYYY-MM-DD'),
        end: dayjs(range.endDate, 'YYYY-MM-DD'),
    }));

    const isDateDisabled = (current) => {
        const date = dayjs(current).startOf('day'); // normalize to day only
        const today = dayjs().startOf('day');

        // Rule 1: Disable past dates
        if (date.isBefore(today)) {
            return true;
        }

        // Rule 2: Disable custom disabled ranges
        return parsedRanges.some(range =>
            date.isSameOrAfter(range.start, 'day') && date.isSameOrBefore(range.end, 'day')
        );
    };

    return (
        <div className='p-4'>
            <div className="container-fluid heading_color mb-3">
                <h4>Banners</h4>
            </div>

            <div className="container-fluid heading_color">
                <form action=" " >
                    <div className="row mb-3">
                        <div className="col-6">
                            <div className="row mb-3">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                        <label
                                            htmlFor="imageUpload"
                                            className="col-form-label required"
                                        >
                                            Header Banner
                                        </label>
                                    </div>

                                    <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                        <div className="input-group">
                                            <input type="file"
                                                id="imageUpload"
                                                name='imageUpload'
                                                accept='.png'
                                                disabled={!useredit && !useradd || bannerForm?.IsType === 'view'}
                                                className="form-control btn_add"
                                                onChange={(e) => handleUploadDoc(e)}
                                            />
                                            <label className="input-group-text" htmlFor="imageUpload">Browse</label>
                                        </div>
                                        {errors?.imageUpload && <p className="text-start text-danger mb-0"> {errors?.imageUpload} </p>}
                                        {errors?.ImagePath && <p className="text-start text-danger mb-0"> {errors?.ImagePath} </p>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                        <label htmlFor="IsCustomDate" className="col-form-label required">Apply custom date</label>
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1 align-content-center">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                id="IsCustomDate"
                                                value="ApplyCustomDate"
                                                className="form-check-input"
                                                name='IsCustomDate'
                                                checked={bannerForm.IsCustomDate}
                                                onChange={(e) => {
                                                    setErrors({})
                                                    setBannnerForm(
                                                        {
                                                            ...bannerForm,
                                                            IsCustomDate: e.target.checked,
                                                            ToDate: null,
                                                            FromDate: null
                                                        }
                                                    )
                                                }}
                                                disabled={!useredit && !useradd || bannerForm?.IsType === 'view'}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6"></div>

                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                        <label htmlFor="imageUpload" className="col-form-label required">Select date range</label>
                                    </div>

                                    <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1 align-content-center">
                                        <div className="input-group">
                                            <RangePicker
                                                className="form-control d-flex"
                                                value={bannerForm.FromDate ? [dayjs(bannerForm.FromDate, 'YYYY-MM-DD'), dayjs(bannerForm.ToDate, 'YYYY-MM-DD')] : null}
                                                onChange={(dates) => handleDateChange(dates)}
                                                disabled={!bannerForm.IsCustomDate || !useredit && !useradd || bannerForm?.IsType === 'view'}
                                                disabledDate={isDateDisabled || new Date() < dayjs().startOf('day')}
                                            />

                                        </div>
                                        {errors?.FromDate && <p className="text-start text-danger mb-0"> {errors?.FromDate} </p>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="row mb-3">
                                <div className='text-center'>
                                    {(bannerForm?.needToUpload || bannerForm?.ImagePath) && (
                                        <>
                                            <img
                                                src={bannerForm?.needToUpload && bannerForm?.File ? URL?.createObjectURL(bannerForm?.File)
                                                    : `${CommonFileURLWithFolder}${bannerForm?.ImagePath}`}
                                                style={{ width: '100%', objectFit: 'fill', aspectRatio: '3 / 1' }}
                                                alt={bannerForm?.ImageName} loading='lazy'
                                            />
                                            <button
                                                type="button" className='closebtnimg' disabled={!useredit && !useradd || bannerForm?.IsType === 'view'}
                                                onClick={(e) => deletehomepagebannerbyid(bannerForm?.ImagePath)}
                                            >&times;</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center pt-5">
                        <button className="btn btn-primary mx-1" id="btnAdd" type='button'
                            onClick={() => AddBanner()}
                            disabled={(!useredit && !useradd) || !bannerForm?.ImagePath || bannerForm?.IsType === 'view'}
                        >
                            {bannerForm.IsType === 'edit' ? 'Update' : 'Add'}
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary mx-1"
                            id="btnClear"
                            disabled={!useredit && !useradd}
                            onClick={() => clearData()}
                        >
                            Clear
                        </button>
                    </div>
                </form>
            </div>
            <div className='mt-3'>
                <CustomTable
                    columns={columns}
                    data={bannerList}
                    PdfExport={false}
                    ExportToExcel={false}
                    disabled={false}
                />
            </div>
        </div>
    )
}

export default Banners